import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartEvent,
} from "chart.js";
import { ITrainHistory } from "@types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface Props {
  data: ITrainHistory[];
  onPointClick?: (id: number) => void;
}

export default function LineChartComponent({ data, onPointClick }: Props) {
  const chartData = {
    labels: data.map((item) => item.id),
    datasets: [
      {
        label: "정확도",
        data: data.map((item) => (item.accuracy ? item.accuracy * 100 : 0)),
        borderColor: "#3b82f6",
        tension: 0.1,
        pointRadius: 5,
        pointHoverRadius: 8,
        hitRadius: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        title: {
          display: true,
          text: "정확도 (%)",
        },
        min: 0,
        max: 100,
      },
      x: {
        title: {
          display: true,
          text: "회차",
        },
      },
    },
    onClick: (event: ChartEvent, elements: any[]) => {
      if (elements.length > 0 && onPointClick) {
        const dataIndex = elements[0].index;
        onPointClick(data[dataIndex].id);
      }
    },
  };

  return (
    <div style={{ width: "600px", height: "400px", paddingBottom: 2 }}>
      <Line data={chartData} options={options} />
    </div>
  );
}
